<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyName="keyName"
      :keySkuName="keySkuName"
      :keySkuCode="keySkuCode"
      :keyDateFrom="keyDateFrom"
      :keyDateTo="keyDateTo"
      @filtrate="filtrate"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :keyName="keyName"
        :keySkuName="keySkuName"
        :keySkuCode="keySkuCode"
        :keyDateFrom="keyDateFrom"
        :keyDateTo="keyDateTo"
        @clearKey="clearKey"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        v-if="isSysRights('Production.getInventoryFlowList')"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/stock-movement/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
    </div>
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import { pagination } from "@components/pagination.js"; //分页
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'

export default {
  components: { LeftSide, Header, pagination, BatchSearchDialog },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("stock-movement-rowsPerPage"))
        ? parseInt(store.get("stock-movement-rowsPerPage"))
        : 10,
      totalPage: 0,
      // totalCount: 0,
      items: [],
      keyName: "",
      keySkuName: "",
      keySkuCode: "",
      keyDateFrom: "",
      keyDateTo: "",
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("stock-movement-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    filtrate(name, skuName, skuCode, dateFrom, dateTo) {
      this.keyName = name;
      this.keySkuName = skuName;
      this.keySkuCode = skuCode;
      this.keyDateFrom = dateFrom;
      this.keyDateTo = dateTo;
      this.toPage(1);
    },
    clearKey(type) {
      if(type=="batchBool") {
        this.getItems(undefined, 'common');
      }
      this[type] = "";
      this.toPage(1);
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.page = 1
      this.rowsPerPage = 10
      this.getItems()
    },
    getItems(s, batch) {
      if (!this.isSysRights("Production.getInventoryFlowList")) return;
      if(batch == 'common'){
        this.batchBool = false
      }
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        warehouseName: this.keyName,
        skuName: this.keySkuName,
        sku: this.keySkuCode,
        startDate: this.keyDateFrom,
        endDate: this.keyDateTo,
      };
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call("api.Production.getInventoryFlowList", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
            }
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (this.page > r.Data.Pagination.totalPage)
            this.page = r.Data.Pagination.totalPage
              ? r.Data.Pagination.totalPage
              : 1;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({
        path: "/stock-movement/" + 1,
        query: this.$route.query,
      });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({
        path: "/stock-movement/" + num,
        query: this.$route.query,
      });
      if (page == num) {
        this.getItems(undefined, 'common');
      }
    },
  },
};
</script>